import {actionTypes} from '../const';
const initState = {
    workdays:[],
    pageNum:1,
    activities:[],
    filteractivities : []
}

const workdays = (state = initState, action) => {

    switch (action.type) {
        case actionTypes.ACTIVITIES_SUCCESS:
            return Object.assign({}, state, {
                activities:action.activities               
            });
        case actionTypes.ITEMS_SUCCESS: 
       
            return Object.assign({}, state, {
                auditData:action.audtitData,
                workdays : action.workdays,
                pageNum: action.pageNum,  
                activities:action.activities,
                locations:action.locations,
                filteractivities : action.filteractivities ? action.filteractivities : []              
            });
        case actionTypes.ITEMS_IS_LOADING:
            return Object.assign({}, state, {
                workdays:[],
                isLoading : action.isLoading,
            });
        case actionTypes.ITEMS_HAS_ERRORED:
            return Object.assign({}, state, {
                workdays:[],
                hasErrored : action.hasErrored
            });
        default:
            return state;
    }
}
export default workdays